function smsMediaIds(rows) {
  const ids = [];
  const seen = new Set();
  for (const row of Array.isArray(rows) ? rows : []) {
    const media = row && Array.isArray(row.media) ? row.media : [];
    for (const item of media) {
      const id = Number(item && item.id);
      if (!id || seen.has(id)) continue;
      seen.add(id);
      ids.push(id);
    }
  }
  return ids;
}

function revokeSmsMediaUrls(urls, revoke) {
  const drop =
    revoke ||
    (typeof URL !== "undefined" && typeof URL.revokeObjectURL === "function"
      ? URL.revokeObjectURL.bind(URL)
      : null);
  if (!drop) return;
  for (const url of Object.values(urls || {})) {
    if (url) drop(url);
  }
}

async function loadSmsMediaObjectUrls(rows, current, deps = {}) {
  const fetchBlob = deps.fetchBlob;
  const createObjectURL = deps.createObjectURL;
  const ids = smsMediaIds(rows);
  const keep = new Set(ids);
  const next = {};
  const revoked = [];
  for (const [key, url] of Object.entries(current || {})) {
    if (keep.has(Number(key)) && url) next[key] = url;
    else if (url) revoked.push(url);
  }
  const missing = ids.filter((id) => !next[id]);
  if (typeof fetchBlob === "function" && typeof createObjectURL === "function") {
    const loaded = await Promise.all(
      missing.map(async (id) => {
        try {
          const blob = await fetchBlob(id);
          if (!blob) return null;
          return { id, url: createObjectURL(blob) };
        } catch (err) {
          return null;
        }
      }),
    );
    for (const item of loaded) {
      if (item && item.url) next[item.id] = item.url;
    }
  }
  return { urls: next, revoked };
}

module.exports = {
  smsMediaIds,
  revokeSmsMediaUrls,
  loadSmsMediaObjectUrls,
};
